<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div>
          <h1 class="page-header">Avtalen är nu undertecknade!</h1>
          <p class="intro">Överenskommelsen och PUB-avtalet är nu undertecknade. Vi kommer nu behandla avtalen och
            återkommer inom kort.</p>
        </div>
        <div class="row mb-3">
          <div class="col-lg-6">
            <OrderList
              :data="{title:'Vad behöver du göra för att komma igång med Digitala samlingen?', items:['Invänta godkännande av avtalen','Köp licens i Webbutiken','Lägg till skolor och användare i Digitala samlingen']}" />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-6">
            <p>Har du frågor eller behöver du hjälp med registreringen? <a
              href="https://www.spsm.se/om-oss/kontakta-oss/">Kontakta oss</a></p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            {{ organisation }}
            <CtaPanel>
              <div class="buttons-container push-buttons-right">
                <router-link :to="`/organisation/${orgId}`" class="btn btn-light">Tillbaka &nbsp;<span
                  class="fas fa-check"></span>
                </router-link>
              </div>
            </CtaPanel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CtaPanel from "../components/CtaPanel.vue";
import { onBeforeRouteLeave, useRoute } from "vue-router";
import OrderList from "@/components/OrderList.vue";

export default defineComponent({

  name: "OrgAgreementConfirmSummary",
  components: {
    CtaPanel,
    OrderList
  },
  setup() {
    const route = useRoute();
    const { orgId } = route.params;

    onBeforeRouteLeave((to, from, next) => {
      sessionStorage.removeItem("agreement");
      next();
    });

    return {
      orgId
    };
  }
});
</script>

<style lang="scss" scoped></style>